var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"task-dot-drop-menu",on:{"click":_vm.clickEvent,"mouseenter":_vm.mouseEvent,"mouseleave":_vm.mouseEvent}},[_c('span',[_c('img',{attrs:{"src":_vm.dotImg}})]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_vm._t("default"):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b2b27f2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widge/TaskDotDropMenu.vue
// module id = null
// module chunks = 